module.exports = __webpack_public_path__ + "img/solutions--mobilization_patient_early.2859f411.png";